import { Dispatch } from "redux";
import { VehiclesModel } from "@app/redux/models";
import { getAllActiveVehicles, getAllModels, getAllOemVehicles } from "../../services/vehicles";
import { RETRIEVE_VEHICLES } from "./types";

export const retrieveAllOemVehicles =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<VehiclesModel> => {
        try {
            const response = await getAllOemVehicles(data);

            dispatch({
                type: RETRIEVE_VEHICLES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const retrieveActiveVehicles =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<VehiclesModel> => {
        try {
            const response = await getAllActiveVehicles(data);

            dispatch({
                type: RETRIEVE_VEHICLES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const retrieveAllVehiclesModels = async () => {
    try {
        const response = await getAllModels();

        return Promise.resolve(response.data.data);
    } catch (err: any) {
        console.log(err.message);
        return Promise.reject(err);
    }
};
